/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EngineRequestDto = {
    /**
     * ID пользователя
     */
    userId: number;
    /**
     * Код заказа
     */
    orderCode: string;
    /**
     * UUID фото шильдика двигателя
     */
    nameplatePhotoUuids?: Array<string>;
    /**
     * Серийный номер двигателя
     */
    serialNumber: string;
    /**
     * Тип двигателя
     */
    engineType: EngineRequestDto.engineType;
    /**
     * Комментарий
     */
    comment?: string;
    /**
     * ID заказа
     */
    orderId?: number;
    /**
     * Дата последнего обслуживания
     */
    lastMaintenance?: string;
    /**
     * Дата следующего обслуживания
     */
    nextMaintenance?: string;
    /**
     * Планируемая дата остановки
     */
    plannedDateOfStop?: string;
    /**
     * Межремонтный интервал в часах
     */
    maintenanceIntervalHours?: number;
};

export namespace EngineRequestDto {

    /**
     * Тип двигателя
     */
    export enum engineType {
        DIESEL = 'DIESEL',
        GASOLINE = 'GASOLINE',
        ELECTRIC = 'ELECTRIC',
        HYBRID = 'HYBRID',
        TURBINE = 'TURBINE',
        STEAM = 'STEAM',
    }


}

